import Vue from 'vue'
import Router from 'vue-router'

import { getUser } from '@/utils/auth'

//apps
import Pos from '../views/apps/pos/Pos.vue'
import Scanner from '../views/apps/pos/Scanner.vue'

//pages
import autentications from './modules/autentications'

//errors
import errors from './modules/errors'

import layouts from '../layout'
import store from '../store'

Vue.use(Router)


const router = new Router({
	mode: 'history',
	base: '/app',
	routes: [
		{
			path: '/',
			alias: '/pos',
			name: 'POS',
			component: Pos,
			meta: {
				auth: true,
				nav: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['POS'],
				roles: ['admin'],
				icon: 'cart-outline'
			}
		},
		{
			path: '/scanner',
			alias: '/scanner',
			name: 'Scanner',
			component: Scanner,
			meta: {
				auth: true,
				nav: true,
				layout: layouts.navLeft,
				searchable: true,
				tags: ['Scanner'],
				roles: ['admin'],
				icon: 'cart-outline'
			}
		},
		{
			path: '/logout',
			beforeEnter(to, from, next) {
				auth.logout()
				next({ path: '/login' })
			}
		},
		autentications,
		errors,
	]
})


const l = {
	contenOnly() {
		store.commit('setLayout', layouts.contenOnly)
	},
	navLeft() {
		store.commit('setLayout', layouts.navLeft)
	},
	navRight() {
		store.commit('setLayout', layouts.navRight)
	},
	navTop() {
		store.commit('setLayout', layouts.navTop)
	},
	navBottom() {
		store.commit('setLayout', layouts.navBottom)
	},
	set(layout) {
		store.commit('setLayout', layout)
	}
}

//insert here login logic
const auth = {
	loggedIn() {
		return store.getters.isLogged
	},
	logout() {
		store.commit('setLogout')
	},
	user() {
		return getUser()
	},
}

router.beforeEach((to, from, next) => {
	let authrequired = false
	if (to && to.meta && to.meta.auth)
		authrequired = true

	//console.log('authrequired', authrequired, to.name)
	next({ name: 'Unauthorized' })
	return
	if (authrequired) {
		if (auth.loggedIn()) {
			if (to.name === 'login') {
				window.location.href = '/app'
				return false
			} else {

				if (!to.meta.roles) {
					next()
					return false
				}
				let enter = false
				for (var i = 0; i < auth.user().roles.length; i++) {
					if (to.meta.roles.includes(auth.user().roles[i].guard_name)) {
						enter = true
					}
				}
				if (!enter)
					next({ name: 'Unauthorized' })

				next()
			}
		} else {
			if (to.name !== 'login') {
				window.location.href = '/app/login'
				return false
			}
			next()
		}
	} else {
		if (auth.loggedIn() && to.name === 'login') {
			window.location.href = '/app'
			return false
		} else {
			next()
		}
	}

	if (to && to.meta && to.meta.layout) {
		l.set(to.meta.layout)
	}
})

router.afterEach((to, from) => {
	setTimeout(() => {
		store.commit('setSplashScreen', false)
	}, 500)
})

export default router